import React, { Component } from "react";
import { get_market_analysis_list } from "../admin.api";
import Snackbar from "../../../components/snackbar/snackbar";
import Loader from "../../../components/loader/loader";
import "./dialog.css";
import TextField from "../../../components/inputs/textfield";

class ViewMarketAnalysis extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      isActive: false,
      snackMessage: "",
      isSnackError: false,
      snackOpen: false,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const { viewData } = this.props;
    
    if (viewData) {
      this.setState({ data: viewData });
    } else {
      // Fallback: fetch from list if no viewData provided
      this.setState({ isActive: true });
      try {
        const res = await get_market_analysis_list();
        const list = Array.isArray(res) ? res : [];
        const row = list.find((x) => String(x?.id) === String(this.props.match?.params?.id));

        if (row) {
          this.setState({ data: row });
        } else {
          this.setState({
            snackMessage: "Record not found",
            isSnackError: true,
            snackOpen: true,
          });
        }
      } catch (err) {
        this.setState({
          snackMessage: err?.response?.data?.message || err?.message || "Failed to fetch data",
          isSnackError: true,
          snackOpen: true,
        });
      } finally {
        this.setState({ isActive: false });
      }
    }
  };

  snackbarClose = (flag) => {
    this.setState({
      snackMessage: "",
      isSnackError: false,
      snackOpen: false,
    });
    if (!flag) {
      this.props.handleClose();
    }
  };
  render() {
    const { data, isActive } = this.state;
    const { open } = this.props;

    if (!open) return null;

    return (
      <React.Fragment>
        <Loader open={isActive} />
        <div className="overlay">
          <div className="big-dia-scroll dialog" style={{ height: 'auto', width: '30vw', overflowY: 'auto', minHeight: '300px' }}>
            <Snackbar
              message={this.state.snackMessage}
              error={this.state.isSnackError}
              open={this.state.snackOpen}
              close={this.snackbarClose}
            />
            <div className=" d-flex flex-column justify-content-between h-100">
              <div>
                <div className="flexDisplay">
                  <div className="diaTitleCon">
                    Market Analysis Details
                  </div>
                  <div className="dia-close" onClick={this.props.handleClose}>
                    <div className="diaCloseCon">
                      <div className="diaClose">&#10005;</div>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ overflowY: "auto" }}>
                <form>
                  <div className="row book-form" style={{ width: "100%" }}>
                    <div className="">
                      <div className="col-12">
                        <TextField
                          id="outlined-basic"
                          label="Opportunity"
                          variant="outlined"
                          value={data?.opportunity ?? ""}
                          name="opportunity"
                          disabled={true}
                          required
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ViewMarketAnalysis;
